import { StandardColumn } from '../../../../components/StandardPage'
import { SkillOption } from '../../../../contexts/ModalContext'

export const accessesScreenKey = 'accesses_users'

export interface AccessUserRow {
  id: number
  name: string
  email: string
  phone: string
  company: string
  status: number | string
  cnpj: string
  adminUser: boolean
  permissions: string[]
  approved: string
  profileId: number | null
  FileInUser: {
    id: number
    GeneralFile: {
      id: number
      fileUrl: string
      title: string
    }
    userId: number
  }[]
  UserSkill?: { Skill: SkillOption }[]
  Profile?: { id: number; name: string } | null
}

export const buildAccessesColumns = (
  profiles: { id: number; name: string }[] = [],
): StandardColumn<AccessUserRow>[] => {
  const resolveProfileName = (row: AccessUserRow): string => {
    if (row.Profile?.name) return row.Profile.name
    if (row.profileId === null || row.profileId === undefined) return '-'
    return profiles.find((profile) => profile.id === row.profileId)?.name ?? '-'
  }

  const resolveSkillNames = (row: AccessUserRow): string => {
    const skillNames = (row.UserSkill ?? []).map((userSkill) => userSkill.Skill.name)
    return skillNames.length > 0 ? skillNames.join(', ') : '-'
  }

  const resolveAttachmentsCount = (row: AccessUserRow): string => {
    const attachmentsCount = (row.FileInUser ?? []).length
    return attachmentsCount > 0 ? String(attachmentsCount) : '-'
  }

  return [
    {
      id: 'name',
      label: 'Usuário',
    },
    {
      id: 'adminUser',
      label: 'Tipo',
      accessor: (row) => (row.profileId === 3 ? 'Admin' : 'Comum'),
      cell: (row) => (row.profileId === 3 ? 'Admin' : 'Comum'),
    },
    {
      id: 'email',
      label: 'Email',
    },
    {
      id: 'phone',
      label: 'Telefone',
    },
    {
      id: 'company',
      label: 'Empresa',
    },
    {
      id: 'profile',
      label: 'Perfil',
      accessor: resolveProfileName,
      cell: resolveProfileName,
      exportValue: resolveProfileName,
    },
    {
      id: 'skills',
      label: 'Habilidades',
      accessor: resolveSkillNames,
      cell: resolveSkillNames,
      exportValue: resolveSkillNames,
    },
    {
      id: 'attachments',
      label: 'Anexos',
      accessor: resolveAttachmentsCount,
      cell: resolveAttachmentsCount,
      exportValue: resolveAttachmentsCount,
    },
  ]
}
